"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');
var _lodash = require('lodash');

var _conversation = require('shared/selectors/conversation');
var _user = require('shared/selectors/user');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _typed = require('shared/hooks/typed');



/* The subset of a typed useSelector this hook needs. Mobile passes its own
 * useAppSelector (typed on the mobile store); web uses the shared one. */


// Only the global toggles mute team and @all mentions; say so next to the
// conversation level, which cannot change it.
const mentionMuteNote = (team, all) => {
  if (team && all) return 'Team and @all mentions are muted in your notification settings'
  if (team) return 'Team mentions are muted in your notification settings'
  if (all) return '@all mentions are muted in your notification settings'
  return null
}







 const useNotifications = (
  { blobjectKey, onSuccess, onFailure },
  useSelector,
) => {
  const useSelect = useSelector || _typed.useAppSelector
  const activeSettings = useSelect(s => _conversation.selectChatNotificationSettings.call(void 0, s, blobjectKey))
  const me = useSelect(_user.selectCurrentUserWithMentionSettings)
  const globalMentionMuteNote = mentionMuteNote(!!me.Suppress_Team_Mentions, !!me.Suppress_All_Mentions)

  const [isMutedForever, setIsMutedForever] = _react.useState.call(void 0, activeSettings.isMutedForever)
  const [mutedUntil, setMutedUntil] = _react.useState.call(void 0, activeSettings.mutedUntil)
  const [isVIP, setIsVIP] = _react.useState.call(void 0, activeSettings.isVIP)
  const [notificationSound, setNotificationSound] = _react.useState.call(void 0, activeSettings.notificationSound)
  const [mentionNotificationLevel, setMentionNotificationLevelState] = _react.useState.call(void 0, activeSettings.mentionNotificationLevel)
  const setMentionNotificationLevel = _react.useCallback.call(void 0, (level) => {
    setMentionNotificationLevelState(level)
    if (level !== 'nothing') setIsMutedForever(false)
  }, [])

  _react.useEffect.call(void 0, 
    () => {
      const localSettings =
        { isMutedForever, mutedUntil, isVIP, notificationSound, mentionNotificationLevel }
      if (_lodash.isMatch.call(void 0, localSettings, activeSettings)) return

      _actions2.default.updateChatNotifications({
        BKey: blobjectKey,
        MuteForever: isMutedForever,
        MuteUntil: mutedUntil,
        VIP: isVIP,
        Sound: notificationSound,
        MentionNotificationLevel: mentionNotificationLevel,
      })
        .then(onSuccess)
        .catch(e => {
          setIsMutedForever(activeSettings.isMutedForever)
          setMutedUntil(activeSettings.mutedUntil)
          setIsVIP(activeSettings.isVIP)
          setNotificationSound(activeSettings.notificationSound)
          setMentionNotificationLevelState(activeSettings.mentionNotificationLevel)
          onFailure(e)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      blobjectKey,
      isMutedForever,
      mutedUntil,
      isVIP,
      notificationSound,
      mentionNotificationLevel,
      onSuccess,
      onFailure,
    ],
  )

  const onMuteUntil = _react.useCallback.call(void 0, 
    (timestamp) => {
      const newDate = new Date(
        timestamp > Date.now() ? timestamp : 0,
      ).toISOString()

      setMutedUntil(newDate)
    },
    [setMutedUntil],
  )

  const onMuteForever = _react.useCallback.call(void 0, 
    () => setIsMutedForever(true),
    [setIsMutedForever],
  )

  // Nothing is saved as a mute, so unmuting also leaves Nothing.
  const onUnmute = _react.useCallback.call(void 0, 
    () => {
      setIsMutedForever(false)
      setMutedUntil(new Date(0).toISOString())
      setMentionNotificationLevelState(level => level === 'nothing' ? 'all' : level)
    },
    [setMutedUntil, setIsMutedForever],
  )

  return {
    isMutedForever,
    mutedUntil,
    isVIP,
    notificationSound,
    mentionNotificationLevel,
    globalMentionMuteNote,
    onMuteUntil,
    onMuteForever,
    onUnmute,
    setIsVIP,
    setNotificationSound,
    setMentionNotificationLevel,
  }
}; exports.useNotifications = useNotifications
